import axios from "axios";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

export default async function addPartnerToCarnet(carnetId, partnerId, prefix) {
  const token = await getOrRefreshFirebaseToken();

  const res = await axios.post(
    `${prefix}carnets/${carnetId}/partners`,
    {
      partner_id: partnerId,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return res.data;
}